import { render } from "./comp-authorization.vue?vue&type=template&id=8d2271d4&scoped=true"
import script from "./comp-authorization.vue?vue&type=script&lang=js"
export * from "./comp-authorization.vue?vue&type=script&lang=js"

import "./comp-authorization.vue?vue&type=style&index=0&id=8d2271d4&lang=less&scoped=true"

import exportComponent from "/usr/local/share/applications/yushifu-shop-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d2271d4"]])

export default __exports__